import {FC} from 'react'

import cn from 'classnames/bind'
import Link from 'next/link'

import s from './Pagination.module.scss'
const cx = cn.bind(s)

interface IPaginationLink {
	className?: string
	url: string | undefined
	isActive?: boolean
	type?: 'nav'
}

const PaginationLink: FC<IPaginationLink> = ({className, url, children, isActive, type}) => {
	const isNavType = type === 'nav'
	const El = !url ? 'span' : 'a'
	return (
		<Link href={url || ''} passHref={!!url} legacyBehavior>
			<El
				className={cx(
					'pagination-link',
					{
						'pagination-link--disabled': !url,
						'pagination-link--is-active': isActive,
						'pagination-link--is-nav': isNavType,
					},
					className,
				)}>
				{children}
			</El>
		</Link>
	)
}

export interface IPaginationData {
	nextUrl?: string
	prevUrl?: string
	linksData: {url: string; pageNumber: number; isActive: boolean}[]
}
interface IPaginationProps {
	className?: string
	data: IPaginationData
}

/** Pagination element component */
const Pagination: FC<IPaginationProps> = ({className, data: {nextUrl, prevUrl, linksData}}) => {
	return (
		<div className={cx('wrapper', className)}>
			{linksData.length > 1 && (
				<ul className={s.list}>
					<li className={cx('list__item')}>
						<PaginationLink url={prevUrl} type="nav">
							Prev
						</PaginationLink>
					</li>
					{linksData.map(({url, isActive, pageNumber}) => (
						<li className={cx('list__item')} key={pageNumber}>
							<PaginationLink {...{url, isActive}}>{pageNumber}</PaginationLink>
						</li>
					))}
					<li className={cx('list__item')}>
						<PaginationLink url={nextUrl} type="nav">
							Next
						</PaginationLink>
					</li>
				</ul>
			)}
		</div>
	)
}

Pagination.displayName = 'Pagination'

export default Pagination
